import { thumbPath, PhotoUrls } from "./thumb";

/** dist/public 下的静态图（不走 /api） */
export function publicAssetUrls(relativePath: string): PhotoUrls {
  const rel = relativePath.replace(/^\/+/, "");
  const thumbRel = thumbPath(rel);

  if (typeof window !== "undefined") {
    const base = new URL(process.env.BASE_URL || "/", window.location.origin);
    return {
      full: new URL(rel, base).href,
      thumb: new URL(thumbRel, base).href,
    };
  }
  const prefix = process.env.BASE_URL || "/";
  return {
    full: `${prefix}${rel}`,
    thumb: `${prefix}${thumbRel}`,
  };
}
